import Component from 'D:/AUTOMFL/UniApp/uniAdmin/windows/components/error-log.vue'
wx.createComponent(Component)